module.exports = __webpack_public_path__ + "static/media/python.5c93be7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/python.png
// module id = 173
// module chunks = 0